import * as Constants from '../constants';
import { createReducer } from '../lib/ReducerUtils';

const INITIAL_STATE = {
  [Constants.Storage.VERSION]: 0,
};
export type StorageState = typeof INITIAL_STATE;

export default createReducer(INITIAL_STATE, {});
